import React from "react"
import QRCode from "qrcode.react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import PageSection from "../../pageSection/pageSection.js"
import H2 from "../../h2/h2.js"
import P from "../../p/p.js"
import QR from "../../qrcode/qrcode"

import styles from "./passportToSpending.module.scss"

import googlePlayImage from "../../../images/android/Google_Play.svg"
import appStoreImage from "../../../images/apple-app-store.svg"
import ovalBlue from "../../../images/home/oval-blue.svg"

const PassportToSpendingSection = (props) => {
  const data = useStaticQuery(graphql`
    query {
      girlHoldingCardImage: file(relativePath: { eq: "home/girl-holding-card.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 730
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)
  const branchLink = props.ccCode ? `sayiDSdmgfb?campaignCode=${props.ccCode}` : "sayiDSdmgfb";
  const bgColor = "#EFF3F8";

  return (
    <PageSection
      backgroundColor="#eff3f9"
      centerVertical
      LeftComponent={() =>
        <div className={styles.imgContainer}>
          <GatsbyImage
            image={getImage(data.girlHoldingCardImage)}
            alt="Teenager smiling and holding a Till debit card"
            width={750}
          />
        </div>
      }
      RightComponent={() =>
        <div className={styles.ovalContainer}>
          <img style={{ width: 300, height: 300, }} src={ovalBlue} alt="Download on the App Store" layout="fixed" />
        </div>
      }
    >
      <div className={styles.passportContainer}>
        <H2 className={styles.h2} slideUp>
          It’s a kid’s passport to the world of smarter spending.
        </H2>
        <P className={styles.body}>
          The fee-free card, in tandem with our app, helps kids make real-life tradeoffs between spending and saving.
        </P>

          {props.device === "ios" &&
            <a className={styles.appStoreImg} href={`${process.env.BRANCH_BASE_URL}/${branchLink}`} target="_blank" rel="noreferrer">
              <img src={appStoreImage} alt="Download on the App Store" layout="fixed" />
            </a>
          }
          {props.device === "android" &&
            <a className={styles.googlePlayImg} href={`${process.env.BRANCH_BASE_URL}/${branchLink}`} target="_blank" rel="noreferrer">
              <img src={googlePlayImage} alt="Download on the Google Play Store Store" layout="fixed" />
            </a>
          }
          {props.device !== "android" && props.device !== "ios"  &&
            <div className={styles.qrCodeContainer}>
              <P>Scan this code with your phone’s camera to download Till.</P>
              <QR bgColor={bgColor} url={`${process.env.BRANCH_BASE_URL}/${branchLink}`} size={128} height={128} width={128} />
            </div>
          }
        
      </div>
    </PageSection>
  )
}

export { PassportToSpendingSection }
